'use client';

import { cn } from '@repo/utils/cn';
import { memo, useCallback } from 'react';

type BarProps = {
  key: string;
  title: string;
  Icon: React.FC<{ className?: string }>;
  onClick: () => void;
};

interface BottomMenuItemProps {
  item: BarProps;
  isActive: boolean;
  onClick: () => void;
  className?: string;
}

const BottomMenuItem = memo(({ item, isActive, onClick, className }: BottomMenuItemProps) => {
  const handleClick = useCallback(() => {
    onClick();
  }, [onClick]);

  return (
    <div
      key={item.key}
      onClick={handleClick}
      className={cn(
        'm-0 flex h-full cursor-pointer flex-col items-center justify-center truncate rounded-none p-0 text-center transition-transform duration-150 ease-in-out',
        isActive
          ? 'scale-105 vt-bottom-menu-item-text-active vt-bottom-menu-item-bg-active'
          : 'scale-95 vt-bottom-menu-item-text vt-bottom-menu-item-bg',
        className
      )}
    >
      <item.Icon className={cn('h-5 w-5')} />
      <span
        className={cn(
          'flex font-semibold vt-text-size-small sm:vt-text-size-small-sm',
          isActive ? 'vt-bottom-menu-item-text-active' : 'vt-bottom-menu-item-text'
        )}
      >
        {item.title}
      </span>
    </div>
  );
});

BottomMenuItem.displayName = 'BottomMenuItem';

export default BottomMenuItem;
